<template>
  <ResponsiveLayout>
    <template #header_end><HeaderHelp /></template>
    <form
      id="login_form"
      class="kds-main-wrapper"
    >
      <CorporateHeader />

      <div class="kds-content-block">
        <p
          class="kds-typography-display-small"
          v-html="$t('generic_login_with_existing_account')"
        />
        <p
          class="kds-typography-paragraph-large"
          v-html="
            $t('b2b_login_welcome_text', {
              name: escapeHtml(selectedCorporate.title),
            })
          "
        />
      </div>

      <div class="kds-content-block">
        <p
          class="kds-typography-title-medium"
          v-html="$t('b2b_login_account_block_title')"
        />
        <TextField
          v-bind="fieldAttrs?.email"
          type="email"
          autocomplete="email"
          :label="$t('generic_field_email')"
          data-qa="email"
        />

        <PasswordField
          v-bind="fieldAttrs.password"
          data-qa="password"
          autocomplete="current-password"
        />
      </div>
    </form>

    <template #actions>
      <BaseButton
        v-bind="submitAttrs"
        data-qa="submit"
        form="login_form"
      >
        {{ $t('generic_login') }}
      </BaseButton>
      <NotRegistered />
    </template>
    <template #footer><FooterLinks v-if="!isFromApp()" /></template>
  </ResponsiveLayout>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import { escapeHtml } from '@shared/utils/escapeHtml'
import useUsStore from '@us/app/stores/useUsStore.js'

import useForm from '@shared/composables/useForm.js'

import ROUTE from '@us/app/router/appModule/names'

import NotRegistered from '@us/app/components/NotRegistered.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import PasswordField from '@shared/components/form/PasswordField.vue'
import TextField from '@shared/components/form/TextField.vue'
import CorporateHeader from '@shared/components/CorporateHeader.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import FooterLinks from '@us/app/components/FooterLinks.vue'
import { isFromApp } from '@shared/helpers/isFromApp.js'
import HeaderHelp from '@us/app/components/HeaderHelp.vue'
import * as apiRequest from '@shared/api-endpoints'

const corporateStore = useCorporateStore()
const usStore = useUsStore()
const router = useRouter()

// persist the corporate the user has selected and use that one instead of the one coming from the user profile
const selectedCorporate = corporateStore.corporate
const formData = computed(() => usStore.formData)

const redirectToNext = async () => {
  await router.push({
    name: ROUTE.SUBSCRIPTION,
    params: {
      slug: selectedCorporate.key,
    },
  })
}

const form = ref({
  email: formData.value.email || '',
  password: formData.value.password || '',
})

const { fieldAttrs, submitAttrs } = useForm(
  form,
  ref({
    email: { validations: ['required'] },
    password: { validations: ['required'] },
  }),
  {
    onSubmit: async () => {
      await apiRequest.login(form.value.email, form.value.password)
    },
    onSuccess: redirectToNext,
    onError: (error) => {
      const status = error?.response?.status

      switch (true) {
        case status === 401:
          // set errors in form
          return {
            email: true,
            password: 'wrong_credentials',
          }
        default:
          console.error(error)
      }
    },
  },
)
</script>
